import * as React from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Paper,
  Collapse,
  TextField,
  TablePagination,
  CircularProgress,
  Modal,
  Tooltip,
} from "@mui/material";
import "../css/AddProject.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useNavigate } from "react-router";
import axios from "axios";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import { BarLoader } from "react-spinners";
import PDF from "../image/PDF.png";
import XLSX_ICON from "../image/XLS.png";
import ID_CARD from "../image/ID_CARD.png";

import DescriptionIcon from "@mui/icons-material/Description";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";

import { FaIdCard } from "react-icons/fa";
export default function NewUserApproval({ notification, setNotificationData }) {
  const [expandedRowId, setExpandedRowId] = React.useState(null);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [isLoader, setIsLoader] = React.useState(false);
  const [showDocuments, setShowDocuments] = React.useState(false);
  const [viewReport, setViewReport] = React.useState(false);
  const [fileError, setFileError] = React.useState("");
  const controllerRef = React.useRef(null);
  const [sortConfig, setSortConfig] = React.useState({
    key: null,
    direction: "asc",
  });
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const navigate = useNavigate();
  const [roleFilter, setRoleFilter] = React.useState("");
  const [modalTitle, setModalTitle] = React.useState("");
  const [loader, setLoader] = React.useState(false);

  const [tableLoader, setTableLoader] = React.useState(false);

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };
  const [showAll, setShowAll] = React.useState(false);

  // 1️⃣ Fetch new users - only fetch, no notification logic here
  const getNewUsers = async () => {
    setTableLoader(true);
    try {
      const response = await axios.get("/cvault/new-user-details-view/");
      let data = response?.data?.data ?? [];

      data = data.map((user) => {
        const {
          role,
          contact_info,
          cmp_found_year,
          company_name,
          acc_number,
          acc_holder_name,
          no_of_employes,
          kyc_ownership_certificate,
          irs_form,
          ein_confirmation_letter,
          photo_id,
          formation_document,
          additional_document,
          date_joined,
          ...rest
        } = user;

        return {
          // 👤 Personal Details (first)
          id: user.id ?? "",
          name: user.user_name || user.name || "",
          email: user.email ?? "",
          phone: contact_info ?? user.phone ?? "",
          role: role ?? "",
          date_joined: date_joined
            ? `${String(new Date(date_joined).getMonth() + 1).padStart(
                2,
                "0"
              )}-${String(new Date(date_joined).getDate()).padStart(
                2,
                "0"
              )}-${new Date(date_joined).getFullYear()}`
            : "",
          photo_id: photo_id ?? "",
          address: user.address ?? "",
          city: user.city ?? "",
          state: user.state ?? "",
          zip_code: user.zip_code ?? "",
          co_owner_name: user.co_owner_name ?? "",
          // designation: user.designation ?? "",

          // 🏢 Company Details (second)
          company_Name: company_name ?? "",
          company_Founded_Year: cmp_found_year ?? "",
          no_of_employees: no_of_employes ?? "",
          formation_document: formation_document ?? "",
          KYC_Beneficial_Ownership_Certificate: kyc_ownership_certificate ?? "",
          EIN_Confirmation_Letter: ein_confirmation_letter ?? "",
          IRS_Form_W9: irs_form ?? "",
          Contractor_License_Information: user.certificates ?? null,
          additional_documents: additional_document ?? [],

          // 🏦 Bank Details (last)
          bank_name: user.bank_name ?? "",
          account_Holder_Name: acc_holder_name ?? "",
          account_Number: acc_number ?? "",
          routing_number: user.routing_number ?? "",
          // banking_detail: banking_detail ?? {},

          // Keep rest if needed
          // ...rest,
        };
      });

      const filteredData = data.map((user) => {
        const { last_login, is_active, designation, id, role, ...rest } = user;
        let filteredUser = { id, role, ...rest };

        if (role === "Owner") {
          const {
            company_Founded_Year,
            company_Name,
            Contractor_License_Information,
            banking_detail,
            // account_Holder_Name,
            no_of_employees,
            // bank_name,
            // account_Number,
            formation_document,
            KYC_Beneficial_Ownership_Certificate,
            EIN_Confirmation_Letter,
            IRS_Form_W9,
            ...restOwner
          } = filteredUser;
          filteredUser = restOwner;
        } else if (role === "Contractor") {
          const {
            co_owner_name,
            banking_detail,
            formation_document,
            KYC_Beneficial_Ownership_Certificate,
            EIN_Confirmation_Letter,
            IRS_Form_W9,
            ...restContractor
          } = filteredUser;
          filteredUser = restContractor;
        }

        return filteredUser;
      });

      const normalized = filteredData.map((u) => ({
        ...u,
        _display: {
          id: u.id,
          name: u.user_name || u.name || "N/A",
          email: u.email || "N/A",
          role: u.role || "N/A",
          date: u.date_joined
            ? (() => {
                const d = new Date(u.date_joined);
                const mm = String(d.getMonth() + 1).padStart(2, "0");
                const dd = String(d.getDate()).padStart(2, "0");
                const yyyy = d.getFullYear();
                return `${mm}-${dd}-${yyyy}`;
              })()
            : "N/A",
        },
      }));

      const sorted = normalized.sort((a, b) => {
        const dateA = new Date(a.date_joined);
        const dateB = new Date(b.date_joined);
        return dateA - dateB;
      });

      setRows(sorted);
      setTableLoader(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch user data.");
      setTableLoader(false);
    }
  };

  React.useEffect(() => {
    getNewUsers();
  }, []);

  React.useEffect(() => {
    if (!notification || !notification.created_by_id) return;
    if (rows.length === 0) return;

    const targetId = notification.created_by_id;
    const targetRole = notification.created_by_role || "";
    setRowsPerPage(5);
    setPage(1);
    setRoleFilter(targetRole);
    const roleRows = rows.filter((r) => r.role === targetRole);

    setTimeout(() => {
      const targetIndex = roleRows.findIndex((r) => r.id === targetId);

      if (targetIndex !== -1) {
        const itemsPerPage = rowsPerPage;
        const targetPage = Math.floor(targetIndex / itemsPerPage) + 1;

        if (targetPage !== page) {
          setPage(targetPage);

          setTimeout(() => {
            setExpandedRowId(targetId);
            const el = document.getElementById(`user-${targetId}`);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 500);
        } else {
          setExpandedRowId(targetId);
          const el = document.getElementById(`user-${targetId}`);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        toast.warning("User request has already been approved.");
      }
    }, 300);

    setNotificationData([]);
  }, [rows, notification]);

  const filteredRows = rows.filter((r) => {
    const q = searchQuery.toLowerCase();
    const matchesSearch =
      r._display.name?.toLowerCase().includes(q) ||
      r._display.email?.toLowerCase().includes(q) ||
      r._display.role?.toLowerCase().includes(q) ||
      r.city?.toLowerCase().includes(q);
    const matchesRole = roleFilter === "" || r._display.role === roleFilter;
    return matchesSearch && matchesRole;
  });

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return filteredRows;
    const sorted = [...filteredRows].sort((a, b) => {
      const aVal = a._display[sortConfig.key];
      const bVal = b._display[sortConfig.key];
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredRows, sortConfig]);

  const toggleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };

  const toggleRow = (id) => {
    setExpandedRowId((prev) => (prev === id ? null : id));
  };

  const paginatedRows = sortedRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const activateUser = async (id) => {
    setLoader(true);
    const payload = {
      new_user_id: id,
      user_active_status: true,
    };
    try {
      const response = await axios.post("/cvault/activate-new-user/", payload, {
        headers: headers,
      });
      setLoader(false);
      toast.success(response?.data?.message);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Error posting data:", error);
      setLoader(false);
    }
  };
  const viewFiles = async (file, iframeShow = false, title) => {
    iframeShow && setShowDocuments(null);

    iframeShow ? setIsLoader(true) : setLoader(true);

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    try {
      const response = await axios.get(`cvault/file-view/?file_path=${file}`, {
        signal,
      });

      setLoader(false);
      setIsLoader(false);
      setViewReport(true);
      let formattedTitle;

      if (title === "IRS_Form_W9") {
        setModalTitle("IRS Form W-9");
      } else if (title === "photo_id") {
        setModalTitle("Photo ID");
      } else {
        formattedTitle = title
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        setModalTitle(formattedTitle);
      }
      setFileError("");

      const downloadFile = (response) => {
        let fileName = response?.data?.file_name;
        let base64Content = response?.data?.base64_content.trim();

        // Automatically download unsupported file types
        if (base64Content.includes(",")) {
          base64Content = base64Content.split(",")[1];
        }

        try {
          // Ensure Base64 string length is a multiple of 4
          while (base64Content.length % 4 !== 0) {
            base64Content += "=";
          }

          // Decode Base64 content
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], {
            type: response?.data?.mimeType,
          });

          // Create a Blob URL and trigger the download
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Free memory
          URL.revokeObjectURL(blobUrl);
          setShowDocuments(null);
        } catch (error) {
          console.error("Invalid Base64 content:", error);
        }
      };

      if (response?.data?.result && response?.data?.base64_content) {
        if (iframeShow) {
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response.data.file_name
            )
          ) {
            setShowDocuments(response?.data); // For displaying inline preview
          } else {
            setViewReport(false);
            downloadFile(response); // For unsupported file types, download the file
          }
        } else {
          setFileError("");
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response?.data?.file_name
            )
          ) {
            // setContractDocuments(true);
            // setSelectedContractDoc(response.data.base64_content); // Set the file to preview
          } else {
            setViewReport(false);

            downloadFile(response); // Download unsupported files
          }
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoader(true);
        setLoader(false);
        setFileError("");
      } else {
        setLoader(false);
        setIsLoader(false);
        iframeShow &&
          setFileError(
            error?.response?.data?.error || "File not found in cloud storage"
          );
        toast.error(
          error?.response?.data?.error || "File not found in cloud storage"
        );
        !iframeShow &&
          toast.error(
            error?.response?.data?.error || "File not found in cloud storage"
          );
      }
    }
  };

  const modelStyleowner = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
    width: "70%",
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
  };

  return (
    <Box sx={{ width: "100%", p: 2, pt: 1 }}>
      {/* Header Row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <div className="form-group mb-0">
          <select
            name="role"
            value={roleFilter}
            onChange={(e) => {
              setRoleFilter(e.target.value);
              setPage(1);
            }}
            style={{ width: "10rem", fontSize: "14px" }}
            className="select-form-control-dropdown form-control"
          >
            <option value="">All Roles</option>
            <option value="Owner">Owner</option>
            <option value="Contractor">Contractor</option>
          </select>
        </div>

        <div className="d-flex align-items-center">
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => {
              const value = e.target.value.replace(/^\s+/, "");
              setSearchQuery(value);
            }}
            sx={{ width: "100%", backgroundColor: "#fff" }}
          />
          <button
            className="btn detail-btn ms-2"
            onClick={() => navigate("/admin")}
            style={{
              backgroundColor: "lightgray",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            Back
          </button>
        </div>
      </Box>

      {/* Table Header */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1.5fr 1.5fr 1fr 1fr 0.7fr",
          fontWeight: 600,
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #e0e0e0",
          p: 1.5,
        }}
      >
        {[
          { key: "name", label: "User Name" },
          { key: "email", label: "Email" },
          { key: "role", label: "Requested Role" },
          { key: "date", label: "Registration Date" },
        ].map((col) => (
          <Box
            key={col.key}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              cursor: "pointer",
              userSelect: "none",
            }}
            onClick={() => toggleSort(col.key)}
          >
            <Typography variant="body2" fontWeight={550}>
              {col.label}
            </Typography>
            {sortConfig.key === col.key &&
              (sortConfig.direction === "asc" ? (
                <ArrowUpwardIcon sx={{ fontSize: 16 }} />
              ) : (
                <ArrowDownwardIcon sx={{ fontSize: 16 }} />
              ))}
          </Box>
        ))}
        <Typography variant="body2" fontWeight={550}>
          Actions
        </Typography>
      </Box>

      {/* Rows */}
      {paginatedRows?.length > 0 ? (
        <>
          {paginatedRows?.map((row) => {
            const expanded = expandedRowId === row._display.id;
            return (
              <Box
                key={row._display.id}
                sx={{ borderBottom: "1px solid #e0e0e0" }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1.5fr 1.5fr 1fr 1fr 0.7fr",
                    alignItems: "center",
                    p: 1.5,
                    backgroundColor: "#fff",
                  }}
                >
                  <Typography variant="body2">{row._display.name}</Typography>
                  <Typography variant="body2">{row._display.email}</Typography>
                  <Typography variant="body2">{row._display.role}</Typography>
                  <Typography variant="body2">{row._display.date}</Typography>
                  <Box
                    sx={{
                      cursor: "pointer",
                      color: "#F5AE41",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                    onClick={() => toggleRow(row._display.id)}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 550 }}>
                      {expanded ? "Close" : "View & Approve"}
                    </Typography>
                    {expanded ? (
                      <KeyboardArrowUpIcon fontSize="small" />
                    ) : (
                      <KeyboardArrowDownIcon fontSize="small" />
                    )}
                  </Box>
                </Box>

                <Collapse in={expanded} timeout={200} unmountOnExit>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      backgroundColor: "#f2f2f2",
                      borderColor: "#eee",
                      borderTop: "1px solid #e0e0e0",
                    }}
                  >
                    <Grid container spacing={2}>
                      {/* ---------- OTHER NON-DOCUMENT FIELDS ---------- */}
                      <Grid container item spacing={2}>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "text.secondary",
                            }}
                          >
                            Personal Information
                          </Typography>
                          <div
                            style={{ borderBottom: "1px solid #e0e0e0ff" }}
                            className="mt-2"
                          />
                        </Grid>
                        {Object.entries(row)
                          .filter(([key]) => {
                            const excluded = [
                              "id",
                              "_display",
                              "Contractor_License_Information",
                              "no_of_employees",
                              "company_Founded_Year",
                              "company_Name",
                              "routing_number",
                              "account_Number",
                              "account_Holder_Name",
                              "bank_name",
                              "KYC_Beneficial_Ownership_Certificate",
                              "formation_document",
                              "IRS_Form_W9",
                              "photo_id",
                              "EIN_Confirmation_Letter",
                              "additional_documents",
                            ];
                            return !excluded.includes(key);
                          })
                          .map(([key, value]) => (
                            <Grid item xs={12} sm={6} md={3} key={key}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: 600,
                                  color: "text.secondary",
                                }}
                              >
                                {key
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (l) => l.toUpperCase())}
                              </Typography>
                              {value || "—"}
                            </Grid>
                          ))}
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={3}
                          // key={key}
                          pt={0}
                        >
                          {Object.entries(row)
                            .filter(([key]) =>
                              [
                                "KYC_Beneficial_Ownership_Certificate",
                                "formation_document",
                                "IRS_Form_W9",
                                "photo_id",
                                "EIN_Confirmation_Letter",
                              ].includes(key)
                            )
                            .map(([key, value]) => (
                              <Grid item xs={12} sm={6} md={3} key={key} pt={0}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  }}
                                >
                                  {key === "IRS_Form_W9"
                                    ? "IRS Form W-9"
                                    : key === "photo_id"
                                    ? "Photo ID"
                                    : key
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (l) =>
                                          l.toUpperCase()
                                        )}
                                </Typography>

                                {value ? (
                                  <div
                                    style={{
                                      width: "160px",
                                      display: "flex",
                                      alignItems: "center",
                                      border: "1px solid lightgray",
                                      borderRadius: "4px",
                                      padding: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => viewFiles(value, true, key)}
                                  >
                                    <Tooltip title="Click here to view">
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                        }}
                                      >
                                        <DescriptionIcon
                                          style={{
                                            fontSize: 26,
                                            color: "#F5AE41",
                                          }}
                                        />
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            color: "#1f1f1fff",
                                            textAlign: "center",
                                            fontSize: "13px",
                                            wordBreak: "break-word",
                                            maxWidth: "100%",
                                          }}
                                        >
                                          {(() => {
                                            const fileName = value
                                              .split("/")
                                              .pop();
                                            const ext = fileName
                                              .split(".")
                                              .pop();
                                            const nameWithoutExt =
                                              fileName.replace(`.${ext}`, "");
                                            return nameWithoutExt.length > 8
                                              ? `${nameWithoutExt.slice(
                                                  0,
                                                  8
                                                )}...${ext}`
                                              : fileName;
                                          })()}
                                        </Typography>
                                      </div>
                                    </Tooltip>
                                  </div>
                                ) : (
                                  "—"
                                )}
                              </Grid>
                            ))}
                        </Grid>
                      </Grid>

                      {row._display.role === "Owner" && (
                        <Grid container item spacing={2}>
                          {Object.entries(row)
                            .filter(([key]) => key === "additional_documents")
                            .map(([key, value]) => (
                              <Grid item xs={12} md={12} key={key} pt={0}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  }}
                                >
                                  Additional Documents
                                </Typography>

                                {Array.isArray(value) && value.length > 0 ? (
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns:
                                        "repeat(auto-fill, minmax(160px, 1fr))",
                                      gap: "12px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    {(showAll ? value : value.slice(0, 3)).map(
                                      (file, idx) => (
                                        <div
                                          key={idx}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            border: "1px solid lightgray",
                                            borderRadius: "4px",
                                            padding: "5px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            viewFiles(file, true, key)
                                          }
                                        >
                                          <Tooltip title="Click here to view">
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                              }}
                                            >
                                              <DescriptionIcon
                                                style={{
                                                  fontSize: 26,
                                                  color: "#F5AE41",
                                                }}
                                              />
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  color: "#1f1f1fff",
                                                  textAlign: "center",
                                                  fontSize: "13px",
                                                  wordBreak: "break-word",
                                                  maxWidth: "100%",
                                                }}
                                              >
                                                {(() => {
                                                  const fileName = file
                                                    .split("/")
                                                    .pop();
                                                  const ext = fileName
                                                    .split(".")
                                                    .pop();
                                                  const nameWithoutExt =
                                                    fileName.replace(
                                                      `.${ext}`,
                                                      ""
                                                    );
                                                  return nameWithoutExt.length >
                                                    8
                                                    ? `${nameWithoutExt.slice(
                                                        0,
                                                        8
                                                      )}...${ext}`
                                                    : fileName;
                                                })()}
                                              </Typography>
                                            </div>
                                          </Tooltip>
                                        </div>
                                      )
                                    )}

                                    {value.length > 3 && (
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setShowAll(!showAll);
                                        }}
                                        style={{
                                          color: "#0d6efd",
                                          cursor: "pointer",
                                          marginTop: "4px",
                                          fontSize: "13px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {showAll
                                          ? "View Less"
                                          : `View All (${value.length - 3})`}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  "—"
                                )}
                              </Grid>
                            ))}
                        </Grid>
                      )}

                      {/* ---------- COMPANY INFO ROW ---------- */}
                      {row._display.role === "Contractor" && (
                        <Grid container item spacing={2}>
                          <Grid item xs={12}>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 600,
                                color: "text.secondary",
                              }}
                            >
                              Business Information
                            </Typography>
                            <div
                              style={{ borderBottom: "1px solid #e0e0e0ff" }}
                              className="mt-2"
                            />
                          </Grid>
                          {Object.entries(row)
                            .filter(([key]) =>
                              [
                                "Contractor_License_Information",
                                "no_of_employees",
                                "company_Founded_Year",
                                "company_Name",
                              ].includes(key)
                            )
                            .map(([key, value]) => (
                              <Grid item xs={12} sm={6} md={3} key={key}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  }}
                                >
                                  {key
                                    .replace(/_/g, " ")
                                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                                </Typography>
                                {value || "—"}
                              </Grid>
                            ))}
                        </Grid>
                      )}
                      {row._display.role === "Contractor" && (
                        <Grid container item spacing={2}>
                          {Object.entries(row)
                            .filter(([key]) => key === "additional_documents")
                            .map(([key, value]) => (
                              <Grid item xs={12} md={12} key={key} pt={0}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  }}
                                >
                                  Additional Documents
                                </Typography>

                                {Array.isArray(value) && value.length > 0 ? (
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns:
                                        "repeat(auto-fill, minmax(160px, 1fr))",
                                      gap: "12px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    {(showAll ? value : value.slice(0, 3)).map(
                                      (file, idx) => (
                                        <div
                                          key={idx}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            border: "1px solid lightgray",
                                            borderRadius: "4px",
                                            padding: "5px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            viewFiles(file, true, key)
                                          }
                                        >
                                          <Tooltip title="Click here to view">
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                              }}
                                            >
                                              <DescriptionIcon
                                                style={{
                                                  fontSize: 26,
                                                  color: "#F5AE41",
                                                }}
                                              />
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  color: "#1f1f1fff",
                                                  textAlign: "center",
                                                  fontSize: "13px",
                                                  wordBreak: "break-word",
                                                  maxWidth: "100%",
                                                }}
                                              >
                                                {(() => {
                                                  const fileName = file
                                                    .split("/")
                                                    .pop();
                                                  const ext = fileName
                                                    .split(".")
                                                    .pop();
                                                  const nameWithoutExt =
                                                    fileName.replace(
                                                      `.${ext}`,
                                                      ""
                                                    );
                                                  return nameWithoutExt.length >
                                                    8
                                                    ? `${nameWithoutExt.slice(
                                                        0,
                                                        8
                                                      )}...${ext}`
                                                    : fileName;
                                                })()}
                                              </Typography>
                                            </div>
                                          </Tooltip>
                                        </div>
                                      )
                                    )}

                                    {value.length > 3 && (
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setShowAll(!showAll);
                                        }}
                                        style={{
                                          color: "#0d6efd",
                                          cursor: "pointer",
                                          marginTop: "4px",
                                          fontSize: "13px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {showAll
                                          ? "View Less"
                                          : `View All (${value.length - 3})`}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  "—"
                                )}
                              </Grid>
                            ))}
                        </Grid>
                      )}

                      {/* ---------- BANK INFO ROW ---------- */}
                      {row._display.role !== "Inspector" && (
                        <Grid container item spacing={2}>
                          <Grid item xs={12}>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 600,
                                color: "text.secondary",
                              }}
                            >
                              Bank Information
                            </Typography>
                            <div
                              style={{ borderBottom: "1px solid #e0e0e0ff" }}
                              className="mt-2"
                            />
                          </Grid>
                          {Object.entries(row)
                            .filter(([key]) =>
                              [
                                "routing_number",
                                "account_Number",
                                "account_Holder_Name",
                                "bank_name",
                              ].includes(key)
                            )
                            .map(([key, value]) => (
                              <Grid item xs={12} sm={6} md={3} key={key}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.secondary",
                                  }}
                                >
                                  {key
                                    .replace(/_/g, " ")
                                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                                </Typography>
                                {value || "—"}
                              </Grid>
                            ))}
                        </Grid>
                      )}
                      {/* ---------- APPROVE BUTTON ---------- */}
                      <Grid item xs={12}>
                        <Box
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
                            onClick={() => activateUser(row._display.id)}
                            disableElevation
                            disabled={loader}
                            sx={{
                              height: "32px",
                              textTransform: "none",
                              backgroundColor: "#F5AE41",
                              color: "#333",
                              "&:hover": {
                                backgroundColor: "#F5AE41",
                              },
                            }}
                          >
                            {loader ? (
                              <>
                                <span className="me-2">Approving...</span>
                                <CircularProgress size={18} color="inherit" />
                              </>
                            ) : (
                              "Approve"
                            )}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>
                </Collapse>
              </Box>
            );
          })}
        </>
      ) : (
        <span className="d-flex justify-content-center my-2 text-muted">
          {tableLoader ? "fetching records..." : "No results found"}
        </span>
      )}
      {/* Pagination */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 2,
          backgroundColor: "#fff",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <TablePagination
          component="div"
          count={sortedRows.length}
          page={page - 1}
          onPageChange={(e, newPage) => setPage(newPage + 1)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(1);
          }}
          rowsPerPageOptions={[5, 10, 15]}
          labelRowsPerPage="Rows per page:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}–${to} of ${count}`
          }
        />
      </Box>

      <Modal
        open={viewReport}
        onClose={() => {
          setShowDocuments(null);
          setFileError("");
          setViewReport(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, top: "50%", height: "85%" }}>
          <div className="h-100">
            {showDocuments && (
              <div
                style={{
                  padding: "0px 10px",
                  width: "100%",
                  height: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <label className="" style={{ fontSize: "14px" }}>
                    {modalTitle} :{" "}
                    <span className="text-primary">
                      {showDocuments.file_name}
                    </span>
                  </label>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowDocuments(null);
                      setFileError("");
                      setViewReport(false);
                    }}
                  >
                    <IoMdClose fontSize={"20px"} />
                  </span>
                </div>

                {/* Image preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                    showDocuments.file_name
                  ) && (
                    <img
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "75vh",
                      }}
                      src={showDocuments.base64_content}
                      alt="Document preview"
                    />
                  )}

                {/* PDF preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(pdf)$/i.test(showDocuments.file_name) && (
                    <iframe
                      style={{ width: "100%", height: "75vh" }}
                      src={showDocuments.base64_content}
                    ></iframe>
                  )}

                {/* Video preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                    showDocuments.file_name
                  ) && (
                    <video
                      style={{ width: "100%", height: "75vh" }}
                      controls
                      src={showDocuments.base64_content}
                    ></video>
                  )}

                {/* Text preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(txt)$/i.test(showDocuments.file_name) && (
                    <iframe
                      style={{ width: "100%", height: "75vh" }}
                      src={showDocuments.base64_content}
                    ></iframe>
                  )}
              </div>
            )}

            {fileError !== "" && (
              <div className="text-danger text-center">{fileError}</div>
            )}
          </div>
        </Box>
      </Modal>
      {isLoader && (
        <div className="loader-overlay">
          <span className="loader-message">
            Fetching document from cloud storage. Please wait...
          </span>

          <BarLoader
            color="#F5AE41"
            width={"80%"}
            height={5}
            className="loader"
            loading={isLoader}
          />
        </div>
      )}
    </Box>
  );
}
